/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface ARTransactionHoldingVisitSelectionModel {
  batchId?: string;
  patientId?: string;
  insuranceId?: string | null;
  visitIds?: Array<string> | null;
  patientPayment?: boolean;
  imaginePayPayment?: boolean;
  unappliedId?: string | null;
  arTransactionId?: string | null;
  updateTransactionIds?: Array<string> | null;
  insuranceLevel?: number;
}
